import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderCargoRailyDraftResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderCargoRailyDraftResponseDataContractCargoCompany = {
  companyName: string;
};

export type BillingsOrderCargoRailyDraftResponseDataContract = {
  model: BillingsOrderCargoRailyDraftResponseDataContractBillingModel;
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  distanceRate: number;
  haltingTimeRate: number;
  discountLimit: number;
  haltingTimeAfterMinutes: number;
  cargoCompany: BillingsOrderCargoRailyDraftResponseDataContractCargoCompany;
};

export type BillingsOrderCargoRailyDraftResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderCargoRailyDraftResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsOrderCargoRailyDraftResponseData = {
  contract: BillingsOrderCargoRailyDraftResponseDataContract;
  billingNodes: BillingsOrderCargoRailyDraftResponseDataBillingNode[];
  discountAmount: number;
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  discount: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderCargoRailyDraftResponseDataCargoOrder;
  planEntryId: string;
  date: Date;
};

type BillingsOrderCargoRailyDraftResponse =
  HttpResponse<BillingsOrderCargoRailyDraftResponseData>;

export default BillingsOrderCargoRailyDraftResponse;
